import ChipLabel, { ChipLabelProps } from "../ChipLabel/ChipLabel";
import CompleteVector from "../../../assets/CompleteVector";
import ProgressVector from "../../../assets/ProgressVector";
import ErrorVector from "../../../assets/ErrorVector";
import { XSquare } from "react-feather";
import { ReactNode } from "react";
import { JobStatus, SmartTargetStatus } from "../../../types/types";

interface StatusChipProps {
	status: StatusChipStatus;
}

export interface StatusChipVariants {
	label: string;
	variant: ChipLabelProps["variant"];
	icon?: ReactNode;
}

type StatusChipStatus = SmartTargetStatus | JobStatus;

function getStatusChipType(status: StatusChipStatus): StatusChipVariants | undefined {
	switch (status) {
		case "finished":
			return { label: "Complete", icon: <CompleteVector />, variant: "positive" };
		case "running":
		case "pending":
			return { label: "Running", icon: <ProgressVector />, variant: "neutral" };
		case "error":
			return { label: "Error", icon: <ErrorVector />, variant: "negative" };
		case "cancelled":
			return { label: "Cancelled", icon: <XSquare />, variant: "negative" };
		case "unachieved":
			return { label: "Unachieved", variant: "warning" };
		default:
			return undefined;
	}
}

export default function StatusChip({ status }: StatusChipProps) {
	const chipType = getStatusChipType(status);
	if (!chipType) return null;

	return <ChipLabel label={chipType.label} icon={chipType.icon} variant={chipType.variant} />;
}
